function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22 19.0644C18.106 19.0644 14.9366 15.8958 14.9366 12.0005C14.9366 8.10523 18.106 4.93662 22 4.93662C25.895 4.93662 29.0645 8.10523 29.0645 12.0005C29.0645 15.8958 25.895 19.0644 22 19.0644ZM22 4C17.5893 4 14 7.58851 14 12.0005C14 16.4115 17.5893 20 22 20C26.4107 20 30 16.4115 30 12.0005C30 7.58851 26.4107 4 22 4Z",
  fill: "#333333"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.3066 0H2.30948C1.03651 0 -0.000244141 1.01657 -0.000244141 2.26633V27.9208C-0.000244141 30.171 1.86429 32.0002 4.15585 32.0002H27.8447C30.1362 32.0002 32.0008 30.171 32.0008 27.9208V24.1806C32.0008 22.9308 30.964 21.9143 29.69 21.9143H27.0764C26.821 21.9143 26.6131 22.1172 26.6131 22.3665C26.6131 22.6159 26.821 22.8188 27.0764 22.8188H29.69C30.4522 22.8188 31.074 23.4305 31.074 24.1806V27.9208C31.074 29.6713 29.6254 31.0957 27.8447 31.0957C26.0649 31.0957 24.6163 29.6713 24.6163 27.9208V22.4422C24.6163 22.1929 24.4083 21.99 24.1529 21.99C23.8975 21.99 23.6896 22.1929 23.6896 22.4422V27.9208C23.6896 29.0242 24.1338 30.0589 24.9383 30.8342L25.2099 31.0957H4.15585C2.3751 31.0957 0.926473 29.6713 0.926473 27.9208V2.26633C0.926473 1.51627 1.54832 0.905523 2.30948 0.905523H22.3066C23.0687 0.905523 23.6896 1.51627 23.6896 2.26633C23.6896 2.51669 23.8975 2.7196 24.1529 2.7196C24.4083 2.7196 24.6163 2.51669 24.6163 2.26633C24.6163 1.01657 23.5806 0 22.3066 0Z",
  fill: "#333333"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.7573 19.122H5.24171C5.12802 19.122 5 19.277 5 19.5C5 19.723 5.12802 19.878 5.24171 19.878H12.7573C12.872 19.878 13 19.723 13 19.5C13 19.277 12.872 19.122 12.7573 19.122Z",
  fill: "#333333"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.24982 9.122C5.13232 9.122 5 9.277 5 9.5C5 9.723 5.13232 9.878 5.24982 9.878H10.7491C10.8677 9.878 11 9.723 11 9.5C11 9.277 10.8677 9.122 10.7491 9.122H5.24982Z",
  fill: "#333333"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.7573 14.122H5.24171C5.12802 14.122 5 14.277 5 14.5C5 14.723 5.12802 14.878 5.24171 14.878H12.7573C12.872 14.878 13 14.723 13 14.5C13 14.277 12.872 14.122 12.7573 14.122Z",
  fill: "#333333"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.5088 8.5293H22.5088V7.5293H21.5088V8.5293ZM21.5088 16.5293H22.5088V10.5293H21.5088V16.5293Z",
  fill: "#333333"
});

var SvgOrderStatusIcon = function SvgOrderStatusIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOrderStatusIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Order_status_icon.bbd709ee.svg";
export { ForwardRef as ReactComponent };